/**
 * WHYSHIFT Editorial Campaign — pause hosted MP4 when off screen.
 */
function initWhyshiftEditorialCampaign(section) {
  if (section.dataset.whyshiftEditorialInit === 'true') return;
  if (section.dataset.pauseOffscreen !== 'true') return;

  const videos = section.querySelectorAll('[data-whyshift-editorial-video]');
  if (videos.length === 0) return;

  section.dataset.whyshiftEditorialInit = 'true';

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;

        if (entry.isIntersecting) {
          if (video.dataset.whyshiftWasPlaying === 'true') {
            video.play().catch(() => {});
          }
          return;
        }

        if (!video.paused) {
          video.dataset.whyshiftWasPlaying = 'true';
          video.pause();
        } else {
          video.dataset.whyshiftWasPlaying = 'false';
        }
      });
    },
    { threshold: 0.35 }
  );

  videos.forEach((video) => observer.observe(video));
}

function initAllWhyshiftEditorialCampaign() {
  document.querySelectorAll('.whyshift-editorial-campaign').forEach(initWhyshiftEditorialCampaign);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllWhyshiftEditorialCampaign);
} else {
  initAllWhyshiftEditorialCampaign();
}

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.querySelector('.whyshift-editorial-campaign') || event.target.closest('.whyshift-editorial-campaign');
  if (section) initWhyshiftEditorialCampaign(section);
});
